import React, { useState, useEffect, useCallback } from 'react'
import { withTranslation } from 'react-i18next'
import { useSelector, useDispatch } from 'react-redux'
// import MasterNumber from '../../YourInformation/components/MasterNumber'
// import PlateNumber from '../../YourInformation/components/PlateNumber'
// import VinSerialNumber from '../../YourInformation/components/VinSerialNumber'
import { clearListInfoAction, listAddAction } from 'redux/actions'
import moment from 'moment-timezone'
import BusinessName from '../BusinessName'
import MasterNumber from '../MasterNumber'
// import styles from '../BusinessVehicleInformation.module.scss';
import { findDuplicateMasterNumber } from "../../../../../redux/reducers/appReducer";

// import { processMasterNumberAction } from 'redux/reducers/apiReducers/processMasterNumberReducer'
// import { getServiceAvailableAction } from 'redux/reducers/apiReducers/serviceAvailableReducer'
// var unidecode = require('unidecode')
const AddBusinessVehicleView = ({ t, i18n, setIsError }) => {
    const dispatch = useDispatch()

    const timezone = process.env.REACT_APP_TIME_ZONE.toString()
    moment.tz.setDefault(timezone)


    const [errMsg, setErrMsg] = useState('');

    const [businessNameValid, setBusinessNameValid] = useState('')
    const [masterNumberValid, setMasterNumberValid] = useState('')

    const [businessNameError, setBusinessNameError] = useState('business_vehicle_info.business_name_error')
    const [masterNumberError, setMasterNumberError] = useState('business_vehicle_info.master_number_error')

    const { businessName, masterNumber, businessVehicles } = useSelector((state) => state.app.businessVehicleInformation)

    const houseHoldMembers = useSelector((state) => state.app.personalInformation.houseHoldMembers);
    const jointVehicles = useSelector((state) => state.app.jointlyOwnedVehicleInformation.vehicles);
    // const businessVehicles = useSelector((state) => state.app.businessVehicleInformation.businessVehicles);


    useEffect(() => {
        try {
            dispatch(clearListInfoAction("businessVehicleInformation"))
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }, [dispatch, setIsError])

    const isDuplicate = useCallback((newVehicle) => {
        const foundDuplicate = findDuplicateMasterNumber(newVehicle.masterNumber, houseHoldMembers, jointVehicles, businessVehicles);
        if (foundDuplicate) {
            setErrMsg('household_list.found_duplicate')
        } else {
            setErrMsg('')
        }
        return foundDuplicate
    }, [jointVehicles, setErrMsg, businessVehicles, houseHoldMembers]);

    const onAddBusinessVehicle = () => {
        try {
            const newVehicle = {
                businessName, masterNumber
            }
            if (validateFields() && !isDuplicate(newVehicle)) {
                dispatch(listAddAction("businessVehicleInformation", newVehicle));
                dispatch(clearListInfoAction("businessVehicleInformation"))
                setMasterNumberValid('')
                setBusinessNameValid('')
                window.scrollTo(0, 0)
            }
        } catch (e) {
            console.log(e)
            // setErrMsg('your_information.service_not_available_error')
        }
    }

    const validateFields = () => {
        try {
            validateBusinessName(businessName)
            validateMasterNumber(masterNumber)

            if (businessName === '') {
                setBusinessNameValid(false)
            }
            if (masterNumber === '') {
                setMasterNumberValid(false)
            }

            return (
                businessNameValid === true &&
                masterNumberValid === true &&

                businessName !== '' &&
                masterNumber !== ''
            )
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    const validateBusinessName = (name) => {
        try {
            const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ& ]*$/)
            if (name.length > 0) {
                if (regex.test(name)) {
                    setBusinessNameValid(true)
                } else {
                    setBusinessNameValid(false)
                    setBusinessNameError('business_vehicle_info.business_name_error_invalid')
                }
            } else {
                setBusinessNameValid(false)
                setBusinessNameError('business_vehicle_info.business_name_error')
            }
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    const validateMasterNumber = (number) => {
        try {
            const regex = RegExp(/^[a-zA-Z\s]{5}[0-9]{9}$/i)
            if (regex.test(number)) {
                setMasterNumberValid(true)
            } else {
                setMasterNumberValid(false)
                setMasterNumberError('business_vehicle_info.master_number_error')
            }
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    return (
        <React.Fragment>
            <div className="row">
                <div className="col-xs-12 col-lg-12">
                    <h2>{t('business_vehicle_info_summary.or_add_another')}</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12 col-lg-12">
                    <BusinessName
                        validateBusinessName={validateBusinessName}
                        businessNameError={businessNameError}
                        businessNameValid={businessNameValid}
                        setIsError={setIsError}
                    />
                    <MasterNumber
                        validateMasterNumber={validateMasterNumber}
                        masterNumberError={masterNumberError}
                        masterNumberValid={masterNumberValid}
                        setIsError={setIsError}
                    />
                </div>
            </div>
            <div className="form-group has-error">
                <button
                    className="btn-lg btn-default"
                    // style={{ marginBottom: errMsg === '' ? '' : '5px' }}
                    onClick={onAddBusinessVehicle}
                    value={t('household_list.add_business_vehicle')}
                    name={t('household_list.add_business_vehicle')}
                >
                    {t('business_vehicle_info_summary.add_business_vehicle')}
                </button>{' '}
                {errMsg === '' ? '' : <i aria-label={t('shared.error')} className="fa fa-exclamation-circle" aria-hidden="true" />}
                <div className="help-block">{t(errMsg)}</div>
            </div>
        </React.Fragment>
    )
}

export default withTranslation('common')(AddBusinessVehicleView)
